import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { services } from '../../services';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslationService } from '../../../../../../shared/services/translations.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-solo-net-wins',
  templateUrl: './apex-badges.component.html'
})
export class ApexBadgesComponent {
  service = 'badges';
  availableServices = services['apex'].filter(service => service.service !== this.service);

  serviceParams = {
    game: 'apex',
    service: 'badges',
    type: 'solo',
    title: {
      en: 'Badge Boosting',
    },
    subtitle: {
      en: 'Unlock any Badge for a Legend of your choice',
      fr: 'Débloquez n\'importe quel Badge pour la Légende de votre choix',
      de: 'Schalte ein beliebiges Abzeichen für eine Legende deiner Wahl frei',
      pt: 'Desbloqueia Badges para uma Legend à tua escolha',
      es: 'Desbloquea cualquier Insignia para una Leyenda de tu elección',
    },
    start: 0,
    desired: 0,
    serviceName: 'badges',
    min: 1,
    max: 10,
    champion: 'Bloodhound',
    badge: 0
  }

  serviceFaqs = {
    en: [
      {
        question: "What Is A Badge Boosting Service?",
        answer: "It is a guaranteed service that allows you to earn specific Apex Legends badges for your favorite characters."
      },
      {
        question: "What If My Legend is Picked?",
        answer: "We can safely abandon the game, thereby accelerating the process."
      },
      {
        question: "In Which Game Mode Will You Earn My Badges?",
        answer: "Badge Boosting is usually completed in Quick Play."
      },
      {
        question: "For Legend Specific Badges, What Account Requirements Do I Need?",
        answer: "You just need to make sure you own the Agent or that you have enough in-game currency to purchase it."
      },
      {
        question: "What If I Do not Have Enough In-game Currency?",
        answer: "In that case you can ask the booster to do it in a different Legend or you can talk to the live support chat for further options."
      },
      {
        question: "Can I Request The Same Booster For A Future Purchase?",
        answer: "Yes! Click the heart icon inside the order dashboard to favorite a booster, then easily reassign them to your future orders."
      }
    ],
    fr: [
      {
        question: "Qu'est-ce qu\'un service de boosting de badges?",
        answer: "C\'est un service garanti qui vous permet d\'obtenir des badges Apex Legends spécifiques pour vos personnages préférés."
      },
      {
        question: "Que se passe-t-il si ma légende est déjà choisie?",
        answer: "Nous pouvons abandonner la partie en toute sécurité, ce qui accélère le processus."
      },
      {
        question: "Dans quel mode de jeu allez-vous obtenir mes badges?",
        answer: "Le boost des badges s\'effectue généralement en Quick Play."
      },
      {
        question: "Pour les badges spécifiques aux légendes, quelles sont les conditions de compte requises?",
        answer: "Vous devez simplement vous assurer que vous possédez l\'agent ou que vous avez suffisamment de crédits dans le jeu pour l\'acheter."
      },
      {
        question: "Que faire si je n\'ai pas assez de crédit dans le jeu?",
        réponse: "Dans ce cas, vous pouvez demander au booster de le faire avec une légende différente ou vous pouvez parler au chat de l\'assistance en direct pour d\'autres options."
      },
      {
        question: "Puis-je demander le même booster pour un prochain achat?",
        answer: "Absolument. Il vous suffit d\'évaluer positivement votre booster et notre système vous donnera la possibilité de le solliciter automatiquement pour de futurs services."
      }
    ],
    de: [
      {
        question: "Was ist ein Badge Boosting Service?",
        answer: "Mit diesem Service kannst du für deine Lieblingscharaktere bestimmte Apex Legends-Abzeichen verdienen."
      },
      {
        question: "Was ist, wenn meine Legende ausgewählt wird?",
        answer: "Wir können das Spiel getrost aufgeben und so den Prozess beschleunigen."
      },
      {
        question: "In welchem Spielmodus verdient ihr meine Abzeichen?",
        answer: "Badge Boosting wird normalerweise im Quick Play abgeschlossen."
      },
      {
        question: "Welche Kontovoraussetzungen brauche ich für legenden-spezifische Abzeichen?",
        answer: "Du musst nur sicherstellen, dass du die Legende besitzt oder dass du genug Spielwährung hast, um sie zu kaufen."
      },
      {
        question: "Was ist, wenn ich nicht genug Spielwährung habe?",
        answer: "In diesem Fall kannst du den Booster bitten, es mit einer anderen Legende zu machen, oder du kannst den Live-Support-Chat für weitere Optionen kontaktieren. "
      },
      {
        question: "Kann ich denselben Booster auch für einen späteren Kauf anfordern?",
        answer: "Ja! Klicke im Bestell-Dashboard auf das Herzsymbol, um einen Booster zu deinen Favoriten hinzuzufügen, und weise ihn dann ganz einfach zukünftigen Bestellungen zu."
      }

    ],
    pt: [
      {
        "question": "O Que É Um Serviço De Badge Boosting?",
        "answer": "Badge Boosting é um serviço que permite ganhar Badges específicos de Apex Legends para as tuas Legends favoritas."
      },
      {
        "question": "E Se A Minha Legend For Escolhida?",
        "answer": "Podemos sair do jogo com segurança, acelerando assim o processo."
      },
      {
        "question": "Em Que Modo De Jogo Serão Ganhos Os Meus Badges?",
        "answer": "Badge Boosting é geralmente realizado em Quickplay ou modos de jogos especiais."
      },
      {
        "question": "Para Badges Específicos De Uma Legend, Quais São Os Requisitos Da Conta?",
        "answer": "Basta garantires que possuis a Legend ou que tens ingame currency suficiente para comprá-lo."
      },
      {
        "question": "E Se Não Tiver Ingame Currency Suficiente?",
        "answer": "Nesse caso, podes pedir ao booster para fazer o badge com outra Legend ou podes falar com o suporte ao vivo para discutir outras opções."
      },
      {
        "question": "Posso Escolher O Mesmo Booster Para Uma Compra Futura?",
        "answer": "Sim! Clica no ícone de coração dentro do painel do pedido para marcar um booster como favorito e depois escolhe-o facilmente nos teus próximos pedidos."
      }
    ],
    es: [
      {
        question: "¿Qué es un servicio de boosting de insignias?",
        answer: "Es un servicio garantizado que te permite ganar insignias específicas de Apex Legends para tus personajes favoritos."
      },
      {
        question: "¿Y si eligen mi leyenda?",
        answer: "Podemos abandonar el juego sin peligro, acelerando así el proceso."
      },
      {
        question: "¿En qué modo de juego conseguiré mis insignias?",
        answer: "Boosting de Insignias se completa normalmente en Partida Rápida."
      },
      {
        question: "¿Qué requisitos de cuenta necesito para las Insignias Específicas de Leyenda?",
        answer: "Sólo tienes que asegurarte de que posees el Agente o de que tienes suficiente moneda del juego para comprarlo."
      },
      {
        question: "¿Qué pasa si no tengo suficiente moneda del juego?",
        answer: "En ese caso puedes pedir al booster que lo haga en una Leyenda diferente o puedes hablar con el chat de soporte en vivo para más opciones."
      },
      {
        question: "¿Puedo solicitar el mismo booster para una futura compra?",
        answer: "¡Sí! Haz clic en el ícono de corazón dentro del panel del pedido para añadir un booster a favoritos y así poder reasignarlo fácilmente en tus futuros pedidos."
      }

    ]
  }

  private page = {
    title: {
      en: "Apex Legends - Badge Boosting",
      fr: "Apex Legends - Boosting de Badge",
      de: "Apex Legends - Badge Boosting",
      pt: "Apex Legends - Badge Boosting",
      es: "Apex Legends - Boost de insignias",
    },
    metaDescription: {
      en: "Achieve any Badge in Apex Legends with our professional badge boosting services. Secure your desired badges quickly and safely with our top tier boosters.",
      fr: "Obtenez n\'importe quel badge dans Apex Legends grâce à nos services professionnels de boosting de badges. Décrochez les badges souhaités rapidement et en toute sécurité grâce à nos meilleurs boosters.",
      de: "Mit unserem professionellen Abzeichen Booster Service erreichst du jedes Abzeichen in Apex Legends. Sichere dir die Abzeichen, die du dir wünschst, schnell und sicher mit unseren qualitativ hochwertigen Boostern.",
      pt: "Obtenha qualquer distintivo no Apex Legends com os nossos serviços profissionais de boosting de distintivos. Garanta rapidamente e de forma segura os distintivos desejados com os nossos boosters de topo.",
      es: "Consigue cualquier insignia en Apex Legends con nuestros servicios profesionales de boosting de insignias. Consigue las insignias que desees de forma rápida y segura con nuestros boosters de primer nivel.",
    }
  }

  lang: string = 'en';

  constructor(meta: Meta, title: Title, private route: ActivatedRoute, private router: Router, private translationService: TranslationService, private cookie: CookieService) {
    this.route.params.subscribe(params => {
      if (Object.keys(params).length === 0) {
        const url = this.router.url.split('/');
        if (this.translationService.validLangs.includes(url[1])) {
          this.lang = url[1];
        } else {
          this.lang = this.cookie.get('gg-lang') || 'en';
        }
      } else {
        this.lang = params['lang'] || 'en';
      }
    });

    title.setTitle(this.page.title[this.lang] || this.page.title['en']);
    meta.updateTag(
      {
        name: 'description',
        content: this.page.metaDescription[this.lang] || this.page.metaDescription['en']
      }
    );
  }
}
